(function () {
  'use strict';
  var node = document.querySelector('[data-bioss-secondary-config]');
  var dialog = document.getElementById('bioss-secondary-upsell');
  if (!node || !dialog || typeof dialog.showModal !== 'function' || dialog.dataset.ready) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!config.enabled) return;
  dialog.dataset.ready = 'true';
  var labels = config.labels;
  var root = /^\/[a-zA-Z0-9/_-]*$/.test(config.root) ? config.root : '/';
  if (root.slice(-1) !== '/') root += '/';
  var conjugation = dialog.querySelector('[data-secondary-conjugation]');
  var size = dialog.querySelector('[data-secondary-size]');
  var add = dialog.querySelector('[data-secondary-add]');
  var status = dialog.querySelector('[data-secondary-status]');
  var image = dialog.querySelector('[data-secondary-image]');
  var imageLabel = dialog.querySelector('[data-secondary-image-label]');
  var link = dialog.querySelector('[data-secondary-product-link]');
  var current = null;
  var busy = false;
  var sequence = 0;
  var controller = null;
  var trigger = null;
  var shown = Object.create(null);
  var conjugations = {
    HRP: ['hrp', 'other'], Cy3: ['cy3', 'standard'], FITC: ['fitc', 'standard'],
    BF350: ['bf350', 'abby'], BF405: ['bf405', 'abby'], BF488: ['bf488', 'abby'], BF555: ['bf555', 'abby'],
    BF594: ['bf594', 'abby'], BF647: ['bf647', 'abby'], BF680: ['bf680', 'abby'], BF750: ['bf750', 'abby'],
    Cy5: ['cy5', 'standard'], 'Cy5.5': ['cy5-5', 'standard'], Cy7: ['cy7', 'standard'],
    PE: ['pe', 'standard'], APC: ['apc', 'standard'], PerCP: ['percp', 'standard'], RBITC: ['rbitc', 'standard'], Biotin: ['biotin', 'other']
  };

  function text(selector, value) { dialog.querySelector(selector).textContent = value || ''; }
  function sameOriginProduct(value) {
    try { var u = new URL(value, location.origin); return u.origin === location.origin && /\/products\/[a-z0-9][a-z0-9-]*\/?$/.test(u.pathname) ? u.pathname : ''; } catch (_) { return ''; }
  }
  function imageUrl(value) {
    value = String(value || '').replace(/^http:/, 'https:');
    if (/^\/assets\/[a-zA-Z0-9_.-]+$/.test(value)) return value;
    if (value.indexOf('//') === 0) value = 'https:' + value;
    try { var u = new URL(value, location.origin); return u.protocol === 'https:' && ['biossantibodies.com', 'www.biossusa.com', 'biossusa.com', 'cdn.shopify.com'].indexOf(u.hostname) !== -1 ? u.href : ''; } catch (_) { return ''; }
  }
  function sourceHandle(item) {
    if (item && /^[a-z0-9][a-z0-9-]{0,199}$/.test(item.handle || '')) return item.handle;
    var path = item && sameOriginProduct(item.url || '');
    return path ? path.split('/').filter(Boolean).pop() : '';
  }
  function remembered(handle) {
    if (shown[handle]) return true;
    try { return sessionStorage.getItem('bioss-secondary:' + handle) === '1'; } catch (_) { return false; }
  }
  function recombinantShown(productId) {
    var sample = window.BiossRecombinantSample;
    if (sample && typeof sample.wasShown === 'function' && sample.wasShown(productId)) return true;
    try { return sessionStorage.getItem('bioss-recombinant-shown:' + productId) === '1'; } catch (_) { return false; }
  }
  function validData(data, handle, item) {
    if (!data || data.eligible !== true || data.source_handle !== handle || String(data.source_id) !== String(item.product_id) || ['Rabbit', 'Mouse'].indexOf(data.host) < 0) return false;
    var family = data.host === 'Rabbit' ? 'bs-0295g' : 'bs-0296g';
    if (data.family !== family || !Array.isArray(data.choices)) return false;
    data.choices = data.choices.filter(function (choice) {
      if (!choice || !sameOriginProduct(choice.url) || !Object.prototype.hasOwnProperty.call(conjugations, choice.conjugation) || !Array.isArray(choice.variants)) return false;
      var expected = family + '-' + conjugations[choice.conjugation][0];
      if (choice.handle !== expected || sameOriginProduct(choice.url).split('/').filter(Boolean).pop() !== expected) return false;
      choice.variants = choice.variants.filter(function (v) {
        var sku = v && typeof v.sku === 'string' ? v.sku.toLowerCase().replace(/cy5\.5/g, 'cy5-5') : '';
        return v && Number.isSafeInteger(v.id) && v.id > 0 && (sku === expected || sku.indexOf(expected + '-') === 0) && Number.isSafeInteger(v.price) && v.price > 0 && typeof v.money === 'string';
      });
      return choice.variants.length > 0;
    });
    return data.choices.length > 0;
  }
  function familyInCart(cart, family) {
    return cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      var sku = String(item.sku || '').toLowerCase();
      return item.quantity > 0 && (sku === family || sku.indexOf(family + '-') === 0);
    });
  }
  function cart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }).then(function (data) { if (!data || !Array.isArray(data.items)) throw new Error('cart'); return data; });
  }
  function option(parent, value, title) { var o = document.createElement('option'); o.value = value; o.textContent = title; parent.appendChild(o); }
  function selectedChoice() { return current && conjugation.value !== '' && current.choices[Number(conjugation.value)]; }
  function selectedVariant() { var choice = selectedChoice(); return choice && size.value !== '' && choice.variants[Number(size.value)]; }
  function setImage(choice) {
    var src = imageUrl(choice && choice.image);
    var caption = choice && choice.image_kind === 'representative' ? labels.representative_image : (choice && choice.image_kind === 'product' ? labels.product_image : labels.image_alt);
    image.hidden = !src;
    imageLabel.textContent = src ? caption : labels.missing_image;
    if (src) { image.src = src; image.alt = choice.image_kind === 'representative' ? caption : choice.title; } else { image.removeAttribute('src'); image.alt = ''; }
  }
  image.addEventListener('error', function () { image.hidden = true; imageLabel.textContent = labels.missing_image; });
  function updateVariant() {
    var v = selectedVariant();
    text('[data-secondary-sku]', v ? v.sku : labels.select_first);
    text('[data-secondary-price]', v ? v.money : '');
    add.disabled = busy || !v;
  }
  conjugation.addEventListener('change', function () {
    if (busy) return;
    size.replaceChildren();
    status.textContent = '';
    var choice = selectedChoice();
    size.disabled = !choice;
    if (choice) {
      text('[data-secondary-name]', choice.title);
      choice.variants.forEach(function (v, i) { option(size, String(i), v.title); });
      link.href = sameOriginProduct(choice.url);
      link.hidden = false;
      setImage(choice);
    } else { link.hidden = true; }
    updateVariant();
  });
  size.addEventListener('change', updateVariant);
  function open(data, sourceTrigger) {
    if (recombinantShown(data.source_id)) return;
    if (dialog.open || busy || document.querySelector('dialog[open], [data-bioss-cart-drawer].is-open') || document.visibilityState === 'hidden') return;
    current = data;
    trigger = sourceTrigger && sourceTrigger.isConnected ? sourceTrigger : document.activeElement;
    conjugation.replaceChildren(); size.replaceChildren();
    option(conjugation, '', labels.choose);
    ['abby', 'standard', 'other'].forEach(function (key) {
      var group = document.createElement('optgroup');
      group.label = labels['group_' + key];
      data.choices.forEach(function (choice, i) {
        if (conjugations[choice.conjugation][1] === key) option(group, String(i), choice.conjugation);
      });
      if (group.children.length) conjugation.appendChild(group);
    });
    conjugation.value = '';
    conjugation.disabled = false; size.disabled = true;
    add.hidden = false; add.disabled = true; add.textContent = labels.add;
    status.textContent = '';
    text('[data-secondary-source]', data.source_title);
    text('[data-secondary-match]', labels.match.replace('[host]', data.host));
    text('[data-secondary-name]', data.choices[0].title);
    text('[data-secondary-sku]', labels.select_first);
    text('[data-secondary-price]', '');
    link.hidden = true;
    setImage(data.choices[0]);
    if (window.jQuery) window.jQuery('.cart-preview').stop(true, true).hide();
    dialog.showModal();
    document.body.classList.add('bioss-secondary-upsell-open');
    conjugation.focus();
    shown[data.source_handle] = true;
    try { sessionStorage.setItem('bioss-secondary:' + data.source_handle, '1'); } catch (_) {}
  }
  dialog.querySelectorAll('[data-secondary-close]').forEach(function (button) { button.addEventListener('click', function () { dialog.close(); }); });
  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var controls = Array.from(dialog.querySelectorAll('button:not([disabled]),select:not([disabled]),a[href]')).filter(function (el) { return !el.hidden && el.getClientRects().length; });
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog.addEventListener('close', function () { document.body.classList.remove('bioss-secondary-upsell-open'); if (trigger && trigger.isConnected && !trigger.disabled) trigger.focus(); });

  function onProductAdded(event) {
    if (event.type !== 'bioss:secondary-resume' && window.BiossRecombinantSample && window.BiossRecombinantSample.offerFirst(event.detail)) return;
    var item = event.detail && event.detail.item;
    var handle = sourceHandle(item);
    if (!dialog.isConnected || !handle || !item.product_id || busy || dialog.open || remembered(handle) || recombinantShown(item.product_id)) return;
    var run = ++sequence;
    if (controller) controller.abort();
    controller = new AbortController();
    var signal = controller.signal;
    var timeout = window.setTimeout(function () { if (run === sequence && controller) controller.abort(); }, 4500);
    fetch(root + 'products/' + encodeURIComponent(handle) + '?view=secondary-upsell', { credentials: 'same-origin', cache: 'no-store', signal: signal, headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('recommendation'); return r.json(); })
      .then(function (data) { if (run !== sequence || !validData(data, handle, item)) return; return cart().then(function (contents) { if (run === sequence && !signal.aborted && !familyInCart(contents, data.family)) open(data, event.detail.trigger); }); })
      .catch(function () {})
      .finally(function () { window.clearTimeout(timeout); });
  }
  document.addEventListener('bioss:product-added', onProductAdded);
  document.addEventListener('bioss:secondary-resume', onProductAdded);
  function unload(event) {
    if (!event.target.contains(dialog)) return;
    sequence += 1;
    if (controller) controller.abort();
    if (dialog.open) dialog.close();
    document.removeEventListener('bioss:product-added', onProductAdded);
    document.removeEventListener('bioss:secondary-resume', onProductAdded);
    document.removeEventListener('shopify:section:unload', unload);
  }
  document.addEventListener('shopify:section:unload', unload);
  add.addEventListener('click', function () {
    var variant = selectedVariant();
    if (busy || add.hidden || !variant || !current || !dialog.open) return;
    busy = true; add.disabled = true; conjugation.disabled = true; size.disabled = true;
    add.textContent = labels.adding; status.textContent = '';
    var family = current.family;
    var posted = false;
    cart().then(function (contents) {
      if (familyInCart(contents, family)) { status.textContent = labels.already; add.hidden = true; return; }
      posted = true;
      return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) }).then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (body) { var e = new Error(typeof body.description === 'string' ? body.description : labels.failed); e.confirmed = true; throw e; });
        return r.json().then(function () { status.textContent = labels.added; add.hidden = true; return cart().then(function (contents) { if (window.StyleHatch && typeof window.StyleHatch.updateCartButton === 'function') window.StyleHatch.updateCartButton(contents); document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { count: contents.item_count } })); }).catch(function () {}); });
      });
    }).catch(function (error) {
      status.textContent = posted && !error.confirmed ? labels.uncertain : (error.confirmed ? error.message : labels.failed);
      if (posted && !error.confirmed) add.hidden = true;
    }).finally(function () {
      busy = false;
      add.textContent = labels.add; conjugation.disabled = add.hidden; size.disabled = add.hidden || !selectedChoice();
      updateVariant();
    });
  });
})();
